import {ossContent} from './index.js'

const htmlArr = []

export const showHtml = (str) => {
  if (str=='<p><br></p>') {
    return '';
  }
  // 正则表达式匹配所有的img标签
  let imgRegex = /<img[^>]+src="([^">]+)"/g;
  let imageRegex = /<image[^>]+src="([^">]+)"/g;
  let videoRegex = /<video[^>]+src="([^">]+)"/g;


  // 使用正则表达式找到所有的图片链接
  let match;

  while ((match = imgRegex.exec(str)) !== null) {
    // 修改图片链接
    if (match[1].includes('?')) {
      let a = match[1].split('?')
      htmlArr.push(a[0]);
    } else {
      htmlArr.push(match[1])
    }
  }

  while ((match = imageRegex.exec(str)) !== null) {
    // 修改图片链接
    if (match[1].includes('?')) {
      let a = match[1].split('?')
      htmlArr.push(ossContent(a[0]));
    } else {
      htmlArr.push(match[1])
    }
  }

  while ((match = videoRegex.exec(str)) !== null) {
    // 修改视频链接
    if (match[1].includes('?')) {
      let a = match[1].split('?')
      htmlArr.push(ossContent(a[0]));
    } else {
      htmlArr.push(match[1])
    }
  }
  return getUrl(str)
}

const getUrl = (s) => {
  if(htmlArr.length){
    htmlArr.map(item => {
      let newSrc = ossContent(item)
      s = s.replace(item, newSrc);
    })
  }
  
   console.log('展示时处理富文本数据---->',s)

  return s

}



const htmlArrDel = []
export const delHtml = (str) => {
  if (str=='<p><br></p>') {
    return '';
  }
  // 正则表达式匹配所有的img标签
  let imgRegex = /<img[^>]+src="([^">]+)"/g;
  let imageRegex = /<image[^>]+src="([^">]+)"/g;
  let videoRegex = /<video[^>]+src="([^">]+)"/g;


  // 使用正则表达式找到所有的图片链接
  let match;

  while ((match = imgRegex.exec(str)) !== null) {
    // 修改图片链接
      htmlArrDel.push(match[1])
  }

  while ((match = imageRegex.exec(str)) !== null) {
    // 修改图片链接
      htmlArrDel.push(match[1])
  }

  while ((match = videoRegex.exec(str)) !== null) {
    // 修改视频链接
    htmlArrDel.push(match[1])
  }
  
  const newHtml = str.replace(
    /https:\/\/marathon-bm-file\.oss-cn-beijing\.aliyuncs\.com/g,
    'https://file.marathonbm.com'
  );

  return delUrl(newHtml)
}

const delUrl = (s) => {
  let newSrc = s
  if(s){
    newSrc = newSrc.replace(
    /src="([^"?]+\.(?:jpg|jpeg|png|gif|bmp|webp))\?[^"]*"/gi,
    (match, url) => `src="${decodeURIComponent(url)}"`
    );

  }

  console.log('newSrc',newSrc)

  // newSrc= newSrc.replace(/"marathon-bm-file.oss-cn-beijing.aliyuncs.com"/g, '"file.marathonbm.com"')
  console.log('保存时处理富文本数据---->',enhanceTableStyles(newSrc))
  return enhanceTableStyles(newSrc)

}

/**
 * 修改HTML中所有表格相关元素的样式，保留并合并原有样式
 * @param {string} html - 原始HTML字符串
 * @param {Object} styles - 要添加/覆盖的样式配置
 * @returns {string} 处理后的HTML字符串
 */
function enhanceTableStyles(html, styles = {}) {
  // 默认样式配置
  const defaultStyles = {
    table: 'border-collapse: collapse;border-spacing: 0;',
    tr: 'border: 1px solid #333;',
    th: 'border: 1px solid #333;background:#f5f2f0;',
    td: 'border: 1px solid #333;'
  };

  // 合并用户自定义样式和默认样式
  const mergedStyles = { ...defaultStyles, ...styles };

  // 更健壮的正则表达式，处理复杂属性
  const tagRegex = (tagName) =>
    new RegExp(`<${tagName}\\b((?:[^>"']|"[^"]*"|'[^']*')*)>`, 'gi');

  // 合并样式字符串
  const mergeStyles = (existingStyle, newStyle) => {
    if (!existingStyle) return newStyle;

    const styleMap = {};

    // 将现有样式转换为对象
    existingStyle.split(';').forEach(declaration => {
      const [prop, value] = declaration.split(':').map(s => s.trim());
      if (prop && value) styleMap[prop] = value;
    });

    // 添加/覆盖新样式
    newStyle.split(';').forEach(declaration => {
      const [prop, value] = declaration.split(':').map(s => s.trim());
      if (prop && value) styleMap[prop] = value;
    });

    // 转换回样式字符串
    return Object.entries(styleMap)
      .map(([prop, value]) => `${prop}: ${value}`)
      .join('; ');
  };

  // 处理单个标签类型
  const processTag = (html, tagName, newStyle) => {
    return html.replace(
      tagRegex(tagName),
      (match, attributes) => {
        // 提取现有style属性
        let existingStyle = '';
        let cleanedAttrs = attributes.replace(
          /\s+style\s*=\s*(["'])((?:(?!\1).)*)\1/i,
          (_, quote, style) => {
            existingStyle = style;
            return '';
          }
        ).trim();

        // 合并样式
        const mergedStyle = mergeStyles(existingStyle, newStyle);

        // 重建属性字符串
        const styleAttr = cleanedAttrs
          ? ` ${cleanedAttrs} style="${mergedStyle}"`
          : ` style="${mergedStyle}"`;

        return `<${tagName}${styleAttr}>`;
      }
    );
  };

  // 处理各种表格相关标签
  let result = html;
  for (const [tagName, style] of Object.entries(mergedStyles)) {
    result = processTag(result, tagName, style);
  }

  return result;
}